import React from "react";
import LottiePlayer from "./LottiePlayer";

import spinnerLottieData from "../../../../assets/spinner/VF_Speechmark_intro_Lottie_Red_300.json";

interface SpinnerProps { }

const Spinner: React.FC<SpinnerProps> = () => (
  <div data-cy="spinner">
    <LottiePlayer animationData={spinnerLottieData} />
  </div>
)

export default Spinner;